import { render, staticRenderFns } from "./i-admin-tools.vue?vue&type=template&id=86c8bfb0&scoped=true&"
import script from "./i-admin-tools.vue?vue&type=script&lang=js&"
export * from "./i-admin-tools.vue?vue&type=script&lang=js&"
import style0 from "./i-admin-tools.vue?vue&type=style&index=0&id=86c8bfb0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c8bfb0",
  null
  
)

export default component.exports